import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Paginator } from 'primeng/paginator';
import { GenericService } from 'src/app/services/generic.service';
import { noWhitespaceValidator } from 'src/app/validators/no-whitespace.validator';

@Component({
  selector: 'app-object-group-list',
  templateUrl: './object-group-list.component.html',
  styleUrls: ['./object-group-list.component.css']
})
export class ObjectGroupListComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  Data:any = []
  objectData: any = []
  singleStatusMaster: any= []
  deleteUomMasterId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  first: number = 0;

  groupId: any


  statusTypes = [
    'MDSTATUS'
  ]

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  
  isLoading: any = false
  isSubmited: boolean = false;
  searchFilter: any = ""
  recordName: any = ""
  recordId: any = ""

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllGroupList()
    this.form = this.fb.group({
      groupName: ['',[Validators.required, noWhitespaceValidator]]
    })
    this.editForm = this.fb.group({
      name: [''],
      description: [''],
      type:[''],
    })
  }

  get groupListForm(){
    return this.form.get('groupList') as FormArray;
  }

  groupListObject(){
    return this.fb.group({
      "group": "",
    })
   }
  
   addGroupListArray(){
    this.groupListForm.push(this.groupListObject())
   }

   removeGroupListArray(index: number){
    this.groupListForm.removeAt(index)
   }

  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
    console.log(this.page)

  }

  addObjectGroup(){

    if(this.isSubmited){
      return
    }

    if(!this.form.valid){
      this.toastr.error("Please fill in all required fields")
      this.isSubmited = false
      return
    }

    this.isSubmited = true

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "groupName": this.form.get('groupName').value.trim(),
      "cid": Number(this.cid)
    }
    
    console.log(body)
    this.generic_service.addObjectGroup(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllGroupList()
        this.form.reset()
        this.cancelModel()
        this.toastr.success(response.message)
        this.isSubmited = false

      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
        this.isSubmited = false

      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    this.form.reset()
  }

  getAllGroupList(){
    this.isLoading = true

    this.generic_service.getAllGroupList().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectData = res.response
        this.count = res.response.length

        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


// form.submit(function(){
//     form.submit(function(){
//         return false;
//     });
// });


deleteIdSelect(id: any,list: any){
  this.groupId = id
  this.recordId = list.objectGroupMasterId
  this.recordName = list.groupName
}
  
clearData(){
  this.recordId = "";
  this.recordName = "";
}

deleteGroup(){
  this.generic_service.deleteObjectGroupMaster(this.groupId).subscribe(
    (response:any)=>{
      this.getAllGroupList()
      this.toastr.success(response.message)
      this.cancelModel()
      this.clearData()
      console.log(this.page)
    },
    (err:any)=> {
      console.log(err)
      this.toastr.error(err.errors[0].description)
    }
  )
}


  blockSpecialChars(event: KeyboardEvent): boolean {
    const allowedRegex = /^[a-zA-Z0-9 ]+$/;
    const key = event.key;

    if (key === 'Enter') {
      return true;
    }
    if (!allowedRegex.test(key)) {
      event.preventDefault(); // Block the character
      return false;
    }
    return true;
  }

  @ViewChild(Paginator) paginator!: Paginator;


  refreshAll(){
    // this.page = 1
    this.searchFilter = ""
    this.getAllGroupList()
    this.onTableDataChange({
      first: 0,
      rows: this.tableSize,
      page: 0,
      pageCount: Math.ceil(this.count / this.tableSize)
    });

  }

  getAllGroupByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getAllGroupByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectData = []
          this.count = 0
          return

        }
        this.objectData = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

}